import React from "react";
import { CheckTelephoneCode } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/useValidationSchemaTelephoneCode";
import { checkCodeTelephone } from "src/app/api/FinalizationApi";
import AppCol from "src/commun/composants/grille/AppCol";
import AppRow from "src/commun/composants/grille/AppRow";
import { useAppText } from "src/commun/composants/AppText";
import CodeTelephoneCheckForm from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/CodeTelephoneCheckForm";

export type VerificationTelephoneContainerProps = {
  initialValues: CheckTelephoneCode;
  stepSuivante: () => void;
  stepPrecedente: () => void;
  pageSuivante: (data: any) => void;
};


const CodeTelephoneCheckContainer = ({ initialValues, stepSuivante, stepPrecedente, pageSuivante }: VerificationTelephoneContainerProps) => {
  const { tString } = useAppText();
  const submitSuccessHandler = () => {
    stepSuivante();
  };

  const submitFormAPI = (values: CheckTelephoneCode) => checkCodeTelephone(values);

  return (
    <AppRow>
      <AppCol md={7}>
        <label>{tString("compte.saisie.mobile.message")}</label>
      </AppCol>
      <AppCol md={5}>
        <CodeTelephoneCheckForm
          initialValues={initialValues}
          stepPrecedente={stepPrecedente}
          pageSuivante={pageSuivante}
          submitSuccessHandler={submitSuccessHandler}
          submitFormAPI={submitFormAPI}
          canSkip={true}/>
      </AppCol>
    </AppRow>
  );
};

export default CodeTelephoneCheckContainer;